const contentListItems = [
  {
    text: "Auteur",
    link: "#auteur"
  },
  {
    text: "Titel",
    link: "#titel"
  },
  {
    text: "Trefwoorden",
    link: "#trefwoorden"
  },
  {
    text: "Genre",
    link: "#genre"
  },
  {
    text: "Samenvatting",
    link: "#samenvatting"
  },
  {
    text: "Commentaar",
    link: "#commentaar"
  },
  {
    text: "Opvallende, kenmerkende citaten",
    link: "#citaten"
  },
  {
    text: "Biografie en bibliografie",
    link: "#biografie"
  },
  {
    text: "Over de auteur",
    link: "#overAuteur"
  },
  {
    text: "Over het werk",
    link: "#overBoek"
  }
];

const headings = {
  auteur: {
    nl: "Auteur",
    en: "Author"
  },
  titel: {
    nl: "Titel",
    en: "Title"
  },
  trefwoorden: {
    nl: "Trefwoorden",
    en: "Keywords"
  },
  genre: {
    nl: "Genre",
    en: "Genre"
  },
  samenvatting: {
    nl: "Samenvatting",
    en: "Summary"
  },
  commentaar: {
    nl: "Commentaar",
    en: "Comments"
  },
  citaten: {
    nl: "Opvallende, kenmerkende citaten",
    en: "Striking, distinctive quotes"
  },
  biografie: {
    nl: "Biografie en bibliografie",
    en: "Biography and bibliography"
  },
  bio: {
    nl: "Biografie",
    en: "Biography"
  },
  biblio: {
    nl: "Bibliografie",
    en: "Bibliography"
  },
  overAuteur: {
    nl: "Over de auteur",
    en: "About the author"
  },
  overBoek: {
    nl: "Over het werk",
    en: "About this work"
  }
};

export { contentListItems, headings };
